export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Condicion de Iva',
	plural_model_name_spanish: 'Condiciones de Iva',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}